import api from './api';
import Rules from '@/types/Rules';
import Rule from '@/types/Rule';

class RuleService {
  async fetchRules(): Promise<Rules> {
    try {
      const [publicRules, gameRules] = await Promise.all([
        api.get<Rule[]>('/rules/public'),
        api.get<Rule[]>('/rules/game'),
      ]);

      return {
        publicRules: publicRules,
        gameRules: gameRules,
      };
    } catch (error) {
      console.error('Es gab ein Problem beim Abrufen der Regeln:', error);
      return {
        publicRules: [],
        gameRules: [],
      };
    }
  }
}

export interface PunishmentType {
  id: number;
  type: string;
  value: number;
}

export const fetchPunishmentTypes = async (): Promise<PunishmentType[]> => {
  try {
    return await api.get<PunishmentType[]>('/punishments/types');
  } catch (error) {
    console.error('Es gab ein Problem beim Abrufen des Strafenkatalogs:', error);
    return [];
  }
};

export default new RuleService();
